module.exports = __webpack_public_path__ + "static/img/animales_15.88f7e59a.jpg";